import { Component, ViewChild } from '@angular/core';
import { ShareProvider } from '../../providers/share/share';
import { Button, NavController } from 'ionic-angular';
import { TransferDataPage } from '../../pages/transfer-data/transfer-data';

/**
 * Generated class for the ShareButtonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'trig-share-button',
  templateUrl: 'share-button.html'
})
export class ShareButtonComponent {

  isEditMode = TransferDataPage.isEditMode;

  @ViewChild(Button)
  set button(button: Button) {
    button.setRole('bar-button');
  }

  constructor(public share: ShareProvider, private navCtrl: NavController) {
  }

  handleClick() {
    if (this.isEditMode) {
      this.navCtrl.push(TransferDataPage);
    } else {
      this.share.share();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/share-button/share-button.ts